import { colors } from "#app/theme/v1/colors";
import { fontWeight } from "#app/theme/v1/fontWeights";
import { radius } from "#app/theme/v1/radius";
import { spacing } from "#app/theme/v1/spacing";
import { getFileIcon } from "#shared/helpers/getFileIcon";
import { Icon, IconName } from "#shared/icons/Icon";
import { Anchor } from "#shared/view/components/Anchor";
import { Box } from "#shared/view/components/Box";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

type Props = {
  name: string;
  url: string;
  description?: string;
  iconName?: IconName;
};

export const Doc = ({ name, url, description, iconName }: Props) => {
  return (
    <Box style={styles}>
      <Anchor href={url} target="_blank" style={anchorStyles}>
        <Icon name={iconName || getFileIcon(name)} />{" "}
        <Stack gap={0}>
          <Text fz={"sm"}>{name}</Text>
          <Text fz={"sm"} c={"gray.5"}>
            {description}
          </Text>
        </Stack>
      </Anchor>
    </Box>
  );
};

const styles = {
  padding: spacing.xxs,
  borderRadius: radius.sm,
  backgroundColor: colors.gray[0],
  border: "1px solid",
  borderColor: colors.gray[3],
  width: "fit-content",
};

const anchorStyles = {
  display: "flex",
  alignItems: "center",
  gap: spacing.xxs,
  fontWeight: fontWeight.medium,
  color: "black",
};
